/**
 * booking-catalog.js
 * -------------------
 * Stateless helper for reading the per-page catalog JSON that each
 * booking section renders directly from its own Liquid blocks (see the
 * `[data-booking-catalog]` script tag in booking-step-1.liquid and
 * enhance-event.liquid).
 *
 * This file holds NO product or pricing data itself. Each page owns and
 * emits its own catalog from the same blocks that render its visible
 * cards, so there is only ever one place (the Theme Editor blocks) that
 * merchandising data can come from — never a second JS copy to drift out
 * of sync with it.
 *
 * Also hosts the small formatting/normalization helpers every step needs,
 * so page scripts don't each reinvent money formatting or key matching.
 */
(function (window) {
  'use strict';

  /**
   * Reads and parses a page's catalog JSON block.
   *   BookingCatalog.read(root) -> plain object, or {} if missing/invalid.
   */
  function read(root, selector) {
    selector = selector || '[data-booking-catalog]';
    var scope = root || document;
    var el = scope.querySelector(selector);
    if (!el) return {};

    try {
      var parsed = JSON.parse(el.textContent || '{}');
      return (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) ? parsed : {};
    } catch (e) {
      return {};
    }
  }

  /**
   * Normalizes a key the same way everywhere: trim, lowercase, collapse
   * whitespace/underscores to a dash — so casing or stray spaces in a URL
   * param or a Theme Editor setting can never cause a false "not found".
   */
  function normalizeKey(value) {
    return String(value == null ? '' : value)
      .trim()
      .toLowerCase()
      .replace(/[\s_]+/g, '-');
  }

  /**
   * Formats a price given in cents/paise as a currency string, using the
   * store's Shopify money format when available, with a plain fallback.
   */
  function formatMoney(amount) {
    amount = Number(amount || 0);

    return '₹' + amount.toLocaleString('en-IN', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    });
}

  window.BookingCatalog = {
    read: read,
    normalizeKey: normalizeKey,
    formatMoney: formatMoney
  };
})(window);